import * as Yup from "yup";

export const loginValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("*Must be a valid email address")
    .required("*Email is required"),
  password: Yup.string().required("*Password is required"),
});

export const addUserValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("*Must be a valid email address")
    .required("*Email is required"),
  mobile: Yup.string().required("*Mobile is required"),
  password: Yup.string().required("*Password is required"),
  confirmPassword: Yup.string().required("*Password is required"),
});
